import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from './../../store/entities/page-result';
import LostFoundItem from '../entities/lost-found-issues/lost-found-item';
import LostFoundDetail from '../entities/lost-found-issues/lost-found-detail'
import Ref from '../entities/ref';
interface LostFoundState extends ListState<LostFoundItem>{
    types : Ref[],
    statuses: Ref[],

}

class LostFoundModule extends ListModule<LostFoundState,any,LostFoundItem>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<LostFoundItem>(),
        loading:false,
        types: new Array<Ref>(),
        statuses : new Array<Ref>()
    }
    actions={
        async getAll(context:ActionContext<LostFoundState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/LostFound/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<LostFoundItem>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async get(context:ActionContext<LostFoundState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/LostFound/GetDetail?Id='+payload.data.id);
            return reponse.data.result as LostFoundDetail;
        },
        async getTypes(context:ActionContext<LostFoundState,any>, payload: any){
            let reponse=await Ajax.get('/api/services/app/LostFound/GetTypes', { params : payload.data });
            context.state.types=reponse.data.result.items as Ref[];
        },
        async getStatuses(context:ActionContext<LostFoundState,any>, payload: any){
            let reponse=await Ajax.get('/api/services/app/LostFound/GetStatuses', { params : payload.data } );
            context.state.statuses=reponse.data.result.items as Ref[];
        },
        async resolveLostIssue(context: ActionContext<LostFoundState, any>, payload: any) {
            await Ajax.put('/api/services/app/LostFound/ResolveLostIssue', payload.data);
        },
    };
    mutations={
        setCurrentPage(state:LostFoundState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:LostFoundState,pagesize:number){
            state.pageSize=pagesize;
        }
    }
}
const lostFoundModule=new LostFoundModule();
export default lostFoundModule;